import { Controller } from "@hotwired/stimulus"

// Cycles the word inside data-word-cycle-target="word" through a list, with
// a "slot machine" motion: the current word slides up and out, the next
// word slides up into place from below. Words come from
// data-word-cycle-words-value.
//
// Sizing note: this target is absolutely positioned and clipped by an
// `overflow-hidden` ancestor sized by an invisible sizer span holding the
// widest word, so swapping words never reflows the surrounding text — see
// the word-cycle markup in home/clinici_medicale.html.erb. This controller
// only handles the slide animation; it does not touch layout/sizing.
export default class extends Controller {
  static targets = ["word"]

  static values = {
    words: Array,
    intervalMs: { type: Number, default: 2200 }
  }

  connect() {
    this.index = 0
    this.timer = setInterval(() => this.rotate(), this.intervalMsValue)
  }

  disconnect() {
    clearInterval(this.timer)
    clearTimeout(this.swapTimeout)
  }

  rotate() {
    this.index = (this.index + 1) % this.wordsValue.length
    const word = this.wordsValue[this.index]
    const el = this.wordTarget
    const transition = "transform 0.5s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.5s cubic-bezier(0.22, 1, 0.36, 1)"

    el.style.transition = transition
    el.style.transform = "translateY(-100%)"
    el.style.opacity = "0"

    this.swapTimeout = setTimeout(() => {
      el.textContent = word
      el.style.transition = "none"
      el.style.transform = "translateY(100%)"
      void el.offsetHeight // force reflow so the next transition starts from here

      requestAnimationFrame(() => {
        el.style.transition = transition
        el.style.transform = "translateY(0)"
        el.style.opacity = "1"
      })
    }, 500)
  }
}
